import type { AddOn, SavingAddOn } from "features/Accounts/types";
import { clone } from "lodash";
import { fetchAddOns } from "features/Accounts/state/thunks/addOnsThunk";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import StatusCode from "enums/httpStatusCodes";

const initialState: {
  items: AddOn[];
  isLoading: boolean;
  isAccessAuthorized: boolean;
} = {
  items: [],
  isLoading: false,
  isAccessAuthorized: true,
};

const addOnsSlice = createSlice({
  name: "AddOns",
  initialState,
  reducers: {
    setAddOns: (state, action: PayloadAction<SavingAddOn[]>) => {
      const updatedAddOns = state.items.map((addOn) => clone(addOn));

      updatedAddOns.forEach((addOn) => {
        const savedAddOn = addOn.default ? addOn : action.payload.find((a) => a.id === addOn.id);
        if (savedAddOn) {
          addOn.isEnabled = true;
          addOn.expirationDate = savedAddOn.expirationDate;
        } else {
          addOn.isEnabled = false;
        }
      });

      return {
        ...state,
        items: updatedAddOns,
      };
    },

    resetAddOns: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddOns.pending, (state) => {
        state.isLoading = true;
        state.isAccessAuthorized = true;
      })
      .addCase(fetchAddOns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchAddOns.rejected, (state, action) => {
        if (action.payload?.status === StatusCode.Forbidden) {
          state.isAccessAuthorized = false;
        }

        state.isLoading = false;
      });
  },
});

export const { setAddOns, resetAddOns } = addOnsSlice.actions;

export default addOnsSlice.reducer;
